<dx-popup
  [showTitle]="true"
  [height]="'auto'"
  [width]="800"
  title="CRÉER UNE NOUVELLE PROPOSITION DE COMMANDE"
  [dragEnabled]="true"
  [showCloseButton]="true"
  [(visible)]="displayDialog"
  (onHiding)="closeDialog()"
>
  <form [formGroup]="form" novalidate (ngSubmit)="addPropositionCommande()">

    <!--UNITÉ DE PRODUCTION-->
    <div class="form-group row">
      <label for="udp" class="col-sm-4 col-form-label space">UNITÉ DE PRODUCTION&nbsp;<span
        class="required"></span></label>
      <div class="col-sm-8">
        <dx-select-box
          id="udp"
          [items]="_uniteDeProductionList"
          displayExpr="libelle"
          placeholder="Choisir une unité de production..."
          [searchEnabled]="true"
          [showClearButton]="false"
          formControlName="uniteDeProduction"
          (onValueChanged)="getSecteursFournisseurs()">

          <!-- Template item sélectionné -->
          <div *dxTemplate="let data of 'field'">
            <ng-container *ngIf="!utils.isNullOrEmpty(form.controls['uniteDeProduction'].value)">
              <label class="space no-overflow mg-b-0">
                <yo-site
                  [siteId]="form.controls['uniteDeProduction'].value?.site?.id"
                  [siteLibelle]="form.controls['uniteDeProduction'].value?.libelle">
                </yo-site>
              </label>
            </ng-container>
          </div>

          <!-- Template pour chaque option dans la liste -->
          <div *dxTemplate="let udp of 'item'">
            <span>
              <label class="no-overflow">
                <yo-site [siteId]="udp?.site?.id" [siteLibelle]="udp?.libelle"></yo-site>
              </label>
            </span>
          </div>

        </dx-select-box>

        <yo-control-error label="Unité de production" [control]="form.controls['uniteDeProduction']"></yo-control-error>
      </div>
    </div>

    <!--SECTEUR FOURNISSEUR-->
    <div class="form-group row">
      <label for="fournisseur" class="col-sm-4 col-form-label space ">FOURNISSEUR&nbsp;<span
        class="required"></span></label>
      <div class="col-sm-8">
        <dx-select-box
          id="fournisseur"
          [items]="secteurFournisseurList"
          displayExpr="fournisseurLibelle"
          placeholder="Choisir un fournisseur..."
          [searchEnabled]="true"
          [showClearButton]="false"
          formControlName="udpSecteurFournisseur"
          (onValueChanged)="getJoursLivraisons()">

          <!-- Template item sélectionné -->
          <div *dxTemplate="let item of 'field'">
            <ng-container *ngIf="!utils.isNullOrEmpty(item)">
              <label class="space no-overflow mg-b-0">
                {{ item.fournisseurLibelle | uppercase }} ({{ item.fournisseurCode }})
              </label>
            </ng-container>
          </div>

          <!-- Template pour chaque option dans la liste -->
          <div *dxTemplate="let item of 'item'">
            <span>
              <label class="no-overflow">
                {{ item.fournisseurLibelle | uppercase }} ({{ item.fournisseurCode }})
              </label>
            </span>
          </div>
        </dx-select-box>


        <yo-control-error label="Fournisseur" [control]="form.controls['udpSecteurFournisseur']"></yo-control-error>
      </div>
    </div>

    <!--DATE DE LIVRAISON-->
    <div class="form-group row">
      <label for="dateLiv" class="col-sm-4 col-form-label space">DATE DE LIVRAISON&nbsp;<span
        class="required"></span></label>
      <div class="col-sm-8">
        <dx-date-box
          id="dateLiv"
          formControlName="dateLivraison"
          type="date"
          [displayFormat]="'dd/MM/yyyy'"
          [useMaskBehavior]="true"
          [disabled]="isCalendarDisabled()"
          [showClearButton]="false"
          [showDropDownButton]="true"
          [calendarOptions]="{ cellTemplate: 'dayCellTemplate', firstDayOfWeek: 1 }"
          [disabledDates]="disabledDates">
          <div *dxTemplate="let data of 'dayCellTemplate'">
            <div [ngClass]="getCellClass(data)">{{ data.text }}</div>
          </div>
        </dx-date-box>

        <yo-control-error label="Date de livraison" [control]="form.controls['dateLivraison']"></yo-control-error>
      </div>
    </div>

    <div class="row mg-t-10">
      <div class="col-md-12 text-right">
        <span class="mg-r-5">
          <yo-button type="submit"
                     [theme]="ButtonThemeEnum.ADD"
                     iconClass="fas fa-plus"
                     label="Ajouter"
          ></yo-button>
        </span>
        <yo-button iconClass="fas fa-times"
                   [theme]="ButtonThemeEnum.CANCEL_INNER"
                   (onClick)="closeDialog()"
                   label="Fermer">
        </yo-button>
      </div>
    </div>
  </form>
</dx-popup>
